module.exports = __webpack_public_path__ + "static/img/12.6530376.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/zh/12.png
// module id = It76
// module chunks = 0